<!-- <app-ui-image [url]="kartbildUrl" ui-image-bordered [altText]="'Skadornas geografiska utbredning'"></app-ui-image> -->
<app-resultat-karta-base #mapComponent></app-resultat-karta-base>
